var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ESLBaseElement } from '@exadel/esl/modules/esl-base-element/core';
import { memoize, boolAttr, listen, prop, attr } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPStateModel } from './model';
import { UIPChangeEvent } from './model.change';
import { UIPStateStorage } from './state.storage';
/**
 * UI Playground root custom element definition
 * Container element for {@link UIPPlugin} components
 * Defines the bounds of UI Playground instance
 * Shares the {@link UIPStateModel} instance between {@link UIPPlugin}-s
 */
export class UIPRoot extends ESLBaseElement {
    /** {@link UIPStateModel} instance to store UI Playground state */
    get model() {
        return new UIPStateModel();
    }
    /** Collects snippets template-holders */
    get $snippets() {
        return Array.from(this.querySelectorAll(UIPRoot.SNIPPET_SEL));
    }
    delayedScrollIntoView() {
        setTimeout(() => {
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.storeKey)
            this.storage = new UIPStateStorage(this.storeKey, this.model);
        this.model.snippets = this.$snippets;
        this.model.applyCurrentSnippet(this);
        this.$$attr('ready', true);
        this.$$fire(this.READY_EVENT, { bubbles: false });
        if (this.model.anchorSnippet) {
            this.delayedScrollIntoView();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.model.snippets = [];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'dark-theme') {
            this.$$fire(this.THEME_CHANGE_EVENT, {
                detail: this.darkTheme,
                bubbles: false
            });
        }
    }
    onModelChange({ detail }) {
        this.dispatchEvent(new UIPChangeEvent(this.CHANGE_EVENT, this, detail));
    }
    onSnippetChange({ detail }) {
        this.$$fire(this.SNIPPET_CHANGE_EVENT, { detail, bubbles: false });
    }
}
UIPRoot.is = 'uip-root';
UIPRoot.observedAttributes = ['dark-theme'];
/** CSS query for snippets */
UIPRoot.SNIPPET_SEL = '[uip-snippet]';
__decorate([
    prop('uip:root:ready')
], UIPRoot.prototype, "READY_EVENT", void 0);
__decorate([
    prop('uip:change')
], UIPRoot.prototype, "CHANGE_EVENT", void 0);
__decorate([
    prop('uip:snippet:change')
], UIPRoot.prototype, "SNIPPET_CHANGE_EVENT", void 0);
__decorate([
    prop('uip:theme:change')
], UIPRoot.prototype, "THEME_CHANGE_EVENT", void 0);
__decorate([
    boolAttr()
], UIPRoot.prototype, "darkTheme", void 0);
__decorate([
    attr({ defaultValue: '' })
], UIPRoot.prototype, "storeKey", void 0);
__decorate([
    boolAttr({ readonly: true })
], UIPRoot.prototype, "ready", void 0);
__decorate([
    memoize()
], UIPRoot.prototype, "model", null);
__decorate([
    listen({ event: 'uip:model:change', target: ($this) => $this.model })
], UIPRoot.prototype, "onModelChange", null);
__decorate([
    listen({
        event: 'uip:model:snippet:change',
        target: ($this) => $this.model
    })
], UIPRoot.prototype, "onSnippetChange", null);
